import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { IScannerFeature } from './scanner.feature.state';
import { ScannerState } from './scanner.state';

export const getScannerState: MemoizedSelector<IScannerFeature, ScannerState> = createFeatureSelector<ScannerState>(
  nameof<IScannerFeature>('scannerFeature')
);

export const getIsScannerStarted = createSelector(getScannerState, (state: ScannerState) => state.isScannerStarted);

export const getIsLoading = createSelector(getScannerState, (state: ScannerState) => state.isLoading);

export const getFailures = createSelector(getScannerState, (state: ScannerState) => state.failures);

export const getIsContinuousScan = createSelector(getScannerState, (state: ScannerState) => state.isContinuousScan);

export const getScannerShouldRestart = createSelector(getScannerState, (state: ScannerState) => state.scannerShouldRestart);

export const getTemporaryClosedDetails = createSelector(getScannerState, (state: ScannerState) => {
  return {
    actionToDispatchOnBarcodeScanned: state.actionToDispatchOnBarcodeScanned,
    isTemporaryClosed: state.isTemporaryClosed,
    isContinuousScan: state.isContinuousScan,
  };
});

export const getIsScannerShown = createSelector(getScannerState, (state: ScannerState) => state.isScannerShown);
